export const SUBSCRIPTION_TRANSLATIONS = {
  "subscriptions.nav.public": "Premium",
  "subscriptions.nav.mine": "Mon abonnement",
  "subscriptions.hero.eyebrow": "DES OFFRES CLAIRES, SANS BLOQUER L’ESSENTIEL",
  "subscriptions.hero.title": "Choisissez les outils qui font grandir vos projets",
  "subscriptions.hero.subtitle": "La sécurité, la messagerie et les usages communautaires restent gratuits. Les offres payantes ajoutent visibilité, IA, statistiques et outils professionnels.",
  "subscriptions.cycle.label": "Période de facturation",
  "subscriptions.cycle.monthly": "Mensuel",
  "subscriptions.cycle.annual": "Annuel",
  "subscriptions.cycle.month": "mois",
  "subscriptions.cycle.year": "an",
  "subscriptions.cycle.annual_saving": "Deux mois offerts par rapport au mensuel",
  "subscriptions.recommended": "Recommandé",
  "subscriptions.price.free": "Gratuit",
  "subscriptions.price.from": "À partir de",
  "subscriptions.price.contact": "Sur devis",
  "subscriptions.plan.essential.name": "Eternua Essentiel",
  "subscriptions.plan.essential.tagline": "Tout ce qu’il faut pour participer pleinement à Eternua.",
  "subscriptions.plan.premium.name": "Eternua Premium",
  "subscriptions.plan.premium.tagline": "Plus de visibilité et des outils IA pour aller plus loin.",
  "subscriptions.plan.pro.name": "Eternua Pro",
  "subscriptions.plan.pro.tagline": "Une vitrine et des outils complets pour votre activité.",
  "subscriptions.plan.enterprise.name": "Eternua Entreprise",
  "subscriptions.plan.enterprise.tagline": "Collaboration, gouvernance et volumes adaptés à votre organisation.",
  "subscriptions.cta.register": "Créer un compte gratuit",
  "subscriptions.cta.login": "Se connecter pour choisir",
  "subscriptions.cta.current": "Voir mon abonnement",
  "subscriptions.cta.choose": "Choisir cette offre",
  "subscriptions.cta.unavailable": "Souscription indisponible",
  "subscriptions.cta.contact": "Nous contacter",
  "subscriptions.cta.retry": "Réessayer",
  "subscriptions.cta.compare": "Comparer toutes les fonctionnalités",
  "subscriptions.loading.plans": "Chargement des offres Eternua…",
  "subscriptions.loading.mine": "Synchronisation de votre abonnement…",
  "subscriptions.error.title": "Les abonnements sont momentanément indisponibles",
  "subscriptions.error.description": "Aucune valeur de démonstration n’est affichée. Réessayez pour charger les informations du serveur.",
  "subscriptions.offline.title": "Vous êtes hors ligne",
  "subscriptions.offline.description": "Reconnectez-vous pour consulter les données réelles de votre abonnement.",
  "subscriptions.compare.title": "Comparaison complète",
  "subscriptions.compare.feature": "Fonctionnalité",
  "subscriptions.compare.included": "Inclus",
  "subscriptions.compare.not_included": "Non inclus",
  "subscriptions.explain.title": "Trois leviers, trois usages distincts",
  "subscriptions.explain.boost.title": "Crédits Boost",
  "subscriptions.explain.boost.text": "Un Boost améliore temporairement la visibilité d’une annonce pendant 48 heures. Il ne garantit ni vente, ni réservation, ni résultat.",
  "subscriptions.explain.ai.title": "Actions IA",
  "subscriptions.explain.ai.text": "Une action correspond à une demande d’amélioration, correction, traduction ou suggestion effectuée par les outils IA Eternua.",
  "subscriptions.explain.promo.title": "Crédits promotionnels",
  "subscriptions.explain.promo.text": "Ils financent uniquement des services internes Eternua, comme les boosts, vitrines et actions IA. Ils restent séparés de l’argent réel et des points.",
  "subscriptions.explain.sponsored": "Un boost porte la mention « Mise en avant ». Un espace publicitaire distinct porte la mention « Sponsorisé » ou « Publicité ».",
  "subscriptions.promo.welcome10": "10 crédits promotionnels offerts – valeur d’utilisation maximale de 10 €",
  "subscriptions.promo.non_withdrawable": "Non retirables",
  "subscriptions.promo.non_transferable": "Non transférables",
  "subscriptions.promo.no_member_payment": "Ne peuvent pas payer un autre membre",
  "subscriptions.promo.no_crowdfunding": "Ne peuvent pas financer une cagnotte ou un don",
  "subscriptions.promo.internal_only": "Réservés aux services internes Eternua",
  "subscriptions.faq.title": "Questions fréquentes",
  "subscriptions.faq.free.q": "L’offre gratuite est-elle vraiment utilisable ?",
  "subscriptions.faq.free.a": "Oui. Profil, identité, annonces standards, recherche, messagerie, candidatures, groupes, crowdfunding, agenda, missions, portefeuille et statistiques simples restent disponibles.",
  "subscriptions.faq.messaging.q": "La messagerie ou la sécurité peuvent-elles être bloquées ?",
  "subscriptions.faq.messaging.a": "Non. La messagerie normale, la sécurité et la vérification d’identité ne dépendent jamais d’un abonnement payant.",
  "subscriptions.faq.boost.q": "Un Boost garantit-il une vente ?",
  "subscriptions.faq.boost.a": "Non. Il augmente seulement la visibilité pendant une durée définie. Le contenu sponsorisé reste identifié comme tel.",
  "subscriptions.faq.quotas.q": "Les quotas inutilisés sont-ils reportés ?",
  "subscriptions.faq.quotas.a": "Non. Les crédits Boost et actions IA se renouvellent chaque mois selon l’ancrage de l’abonnement, sans report automatique.",
  "subscriptions.faq.cancel.q": "Que se passe-t-il après une résiliation ?",
  "subscriptions.faq.cancel.a": "Les avantages payants restent actifs jusqu’à la fin de la période déjà réglée. Vos annonces et données ne sont pas supprimées.",
  "subscriptions.faq.enterprise.q": "Comment souscrire à Entreprise ?",
  "subscriptions.faq.enterprise.a": "L’offre est configurée sur devis. Contactez Eternua pour définir collaborateurs, volumes, établissements et gouvernance.",
  "subscriptions.mine.eyebrow": "ESPACE PERSONNEL",
  "subscriptions.mine.title": "Abonnements et promotions",
  "subscriptions.mine.subtitle": "Statut, échéances, boosts, paiements et préférences confirmés par le serveur.",
  "subscriptions.mine.current_offer": "Offre actuelle",
  "subscriptions.mine.status": "Statut",
  "subscriptions.mine.price": "Prix",
  "subscriptions.mine.billing_cycle": "Cycle",
  "subscriptions.mine.next_billing": "Prochaine échéance",
  "subscriptions.mine.ends_at": "Fin des avantages payants",
  "subscriptions.mine.no_due_date": "Aucune échéance",
  "subscriptions.mine.no_end_date": "Aucune fin programmée",
  "subscriptions.mine.change": "Changer d’offre",
  "subscriptions.mine.cancel": "Résilier en ligne",
  "subscriptions.mine.reactivate": "Réactiver l’abonnement",
  "subscriptions.mine.cancel_confirm_title": "Programmer la résiliation ?",
  "subscriptions.mine.cancel_confirm_text": "Vos avantages restent actifs jusqu’à l’échéance affichée. Aucune annonce ni donnée ne sera supprimée.",
  "subscriptions.mine.cancel_confirm": "Confirmer la résiliation",
  "subscriptions.mine.cancel_keep": "Conserver mon offre",
  "subscriptions.mine.action_pending": "Mise à jour sécurisée en cours…",
  "subscriptions.mine.payment_disabled": "Le paiement est volontairement désactivé. Aucun débit réel ne peut être déclenché depuis cette version.",
  "subscriptions.mine.pending_payment": "Activation en attente de confirmation du paiement test.",
  "subscriptions.mine.past_due": "Paiement impayé. Vérifiez votre situation avant l’échéance.",
  "subscriptions.mine.cancel_scheduled": "Résiliation programmée : vos avantages restent actifs jusqu’à la date de fin.",
  "subscriptions.mine.expired": "Cet abonnement est expiré. Seuls les avantages Essentiel restent actifs.",
  "subscriptions.mine.usage_title": "Vos avantages du mois",
  "subscriptions.mine.boosts": "Boosts disponibles",
  "subscriptions.mine.ai_actions": "Actions IA restantes",
  "subscriptions.mine.renews": "Renouvellement",
  "subscriptions.mine.no_renewal": "Pas de renouvellement sur cette offre",
  "subscriptions.mine.promo_title": "Crédits promotionnels",
  "subscriptions.mine.promo_balance": "Solde promotionnel",
  "subscriptions.mine.separate_balances": "Ce solde est techniquement séparé de votre argent réel et de vos points de récompense.",
  "subscriptions.mine.promo_history_link": "Consulter l’historique complet dans le portefeuille",
  "subscriptions.mine.history_title": "Historique d’utilisation",
  "subscriptions.mine.history_empty": "Aucune utilisation enregistrée pour le moment.",
  "subscriptions.mine.changes_title": "Historique des changements",
  "subscriptions.mine.changes_empty": "Aucun changement d’abonnement enregistré.",
  "subscriptions.mine.invoices_title": "Factures",
  "subscriptions.mine.invoices_empty": "Aucune facture réelle n’est disponible.",
  "subscriptions.mine.invoices_empty_detail": "Une facture apparaîtra uniquement après émission par un fournisseur de paiement configuré.",
  "subscriptions.mine.module_title": "Module professionnel principal",
  "subscriptions.mine.module_help": "Choisissez le module qui structure votre vitrine Pro. D’autres modules pourront être ajoutés plus tard.",
  "subscriptions.mine.module_save": "Enregistrer le module",
  "subscriptions.status.incomplete": "Incomplet",
  "subscriptions.status.active": "Actif",
  "subscriptions.status.past_due": "Impayé",
  "subscriptions.status.cancel_scheduled": "Résiliation programmée",
  "subscriptions.status.canceled": "Résilié",
  "subscriptions.status.expired": "Expiré",
  "subscriptions.module.seller": "Vendeur",
  "subscriptions.module.services": "Services",
  "subscriptions.module.host": "Hôte",
  "subscriptions.module.real_estate": "Immobilier",
  "subscriptions.module.recruiter": "Recruteur",
  "subscriptions.module.crowdfunding": "Crowdfunding",
  "subscriptions.event.boost": "Boost consommé",
  "subscriptions.event.ai_action": "Action IA consommée",
  "subscriptions.event.created": "Abonnement créé",
  "subscriptions.event.plan_changed": "Offre modifiée",
  "subscriptions.event.cancel_scheduled": "Résiliation programmée",
  "subscriptions.event.reactivated": "Abonnement réactivé",
  "subscriptions.event.expired": "Abonnement expiré",
  "subscriptions.event.module_changed": "Module professionnel modifié",
  "subscriptions.feature.profile_customization": "Création et personnalisation du profil",
  "subscriptions.feature.identity_and_security": "Vérification d’identité et sécurité",
  "subscriptions.feature.standard_listings": "Publication d’annonces standards",
  "subscriptions.feature.search_favorites_simple_alerts": "Recherche, favoris et alertes simples",
  "subscriptions.feature.member_messaging": "Messagerie entre membres",
  "subscriptions.feature.job_applications": "Candidatures aux offres d’emploi",
  "subscriptions.feature.community_travel_services_groups": "Sorties, voyages, services et groupes",
  "subscriptions.feature.crowdfunding_participation": "Participation au crowdfunding",
  "subscriptions.feature.agenda_missions_points_rewards": "Agenda, missions, points et récompenses",
  "subscriptions.feature.guided_journey": "Parcours guidé par LIA",
  "subscriptions.feature.wallet_and_history": "Portefeuille et historique",
  "subscriptions.feature.simple_statistics": "Statistiques simples",
  "subscriptions.feature.standard_support": "Assistance standard",
  "subscriptions.feature.boost_allowance": "Crédits Boost renouvelés chaque mois",
  "subscriptions.feature.boost_duration": "Mise en avant d’une annonce",
  "subscriptions.feature.scheduled_boosts": "Programmation des boosts",
  "subscriptions.feature.ai_action_allowance": "Actions IA mensuelles",
  "subscriptions.feature.ai_assistance": "Amélioration, correction, traduction et suggestions IA",
  "subscriptions.feature.listing_media": "Photos et vidéos par annonce",
  "subscriptions.feature.listing_workflow": "Brouillons, duplication et programmation",
  "subscriptions.feature.advanced_alerts": "Alertes avancées et recherches enregistrées",
  "subscriptions.feature.statistics_range": "Statistiques détaillées",
  "subscriptions.feature.premium_profile": "Profil Premium personnalisable",
  "subscriptions.feature.premium_badge": "Badge Premium distinct de la mention « Identité déclarée »",
  "subscriptions.feature.partner_ads": "Publicité partenaire",
  "subscriptions.feature.early_access": "Accès anticipé aux nouveautés",
  "subscriptions.feature.professional_storefront": "Vitrine professionnelle",
  "subscriptions.feature.catalogue_collections": "Catalogue par collections",
  "subscriptions.feature.scheduled_promotions": "Promotions et publications programmées",
  "subscriptions.feature.professional_statistics": "Statistiques professionnelles",
  "subscriptions.feature.bulk_listing_management": "Gestion groupée des annonces",
  "subscriptions.feature.csv_import_export": "Import et export CSV",
  "subscriptions.feature.message_templates": "Modèles de messages et réponses rapides",
  "subscriptions.feature.stock_and_availability": "Stocks et disponibilités",
  "subscriptions.feature.booking_calendar": "Calendrier de réservations",
  "subscriptions.feature.agenda_sync": "Synchronisation avec l’agenda Eternua",
  "subscriptions.feature.accounting_exports": "Exports comptables",
  "subscriptions.feature.monthly_reports": "Rapports mensuels",
  "subscriptions.feature.multilingual_translation": "Traduction multilingue",
  "subscriptions.feature.professional_modules": "Modules professionnels",
  "subscriptions.feature.multiple_collaborators": "Plusieurs collaborateurs",
  "subscriptions.feature.roles_and_approval": "Rôles propriétaire, administrateur, éditeur, support et analyste, avec validation avant publication",
  "subscriptions.feature.multiple_locations": "Plusieurs boutiques, agences ou établissements",
  "subscriptions.feature.global_team_dashboard": "Tableau de bord global et statistiques d’équipe",
  "subscriptions.feature.action_audit_log": "Historique des actions",
  "subscriptions.feature.centralized_billing": "Facturation centralisée",
  "subscriptions.feature.advanced_exports": "Exports avancés",
  "subscriptions.feature.enforced_collaborator_2fa": "2FA imposée aux collaborateurs",
  "subscriptions.feature.future_api_webhooks": "API et webhooks préparés",
  "subscriptions.value.0": "0",
  "subscriptions.value.3_monthly": "3 / mois",
  "subscriptions.value.20_monthly": "20 / mois",
  "subscriptions.value.25_monthly": "25 / mois",
  "subscriptions.value.150_monthly": "150 / mois",
  "subscriptions.value.custom": "Volume personnalisé",
  "subscriptions.value.48_hours": "48 heures",
  "subscriptions.value.standard": "Standard",
  "subscriptions.value.extended": "Étendu",
  "subscriptions.value.simple": "Simples",
  "subscriptions.value.7_30_90_days": "7, 30 et 90 jours",
  "subscriptions.value.professional": "Professionnelles",
  "subscriptions.value.team": "Par équipe et globales",
  "subscriptions.value.identified": "Présente et identifiée",
  "subscriptions.value.none": "Aucune",
  "subscriptions.value.prepared": "Préparés, non activés",
};
